import { render, staticRenderFns } from "./CmsLayout.vue?vue&type=template&id=48d224f0&scoped=true"
import script from "./CmsLayout.vue?vue&type=script&lang=js"
export * from "./CmsLayout.vue?vue&type=script&lang=js"
import style0 from "./CmsLayout.vue?vue&type=style&index=0&id=48d224f0&prod&lang=css"
import style1 from "./CmsLayout.vue?vue&type=style&index=1&id=48d224f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d224f0",
  null
  
)

export default component.exports